export default async function buscarEndereco(cep, endereco, bairro, cidade, estado, erroCep) {
  const cepLimpo = cep.value.replace(/\D/g, '')
  
  if (cepLimpo.length !== 8) {
    erroCep.value = 'CEP inválido.'
    return
  }

  try {
    const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
    const data = await res.json()

    if (data.erro) {
      erroCep.value = 'CEP não encontrado.'
      return
    }

    endereco.value = data.logradouro || ''
    bairro.value = data.bairro || ''
    cidade.value = data.localidade || ''
    estado.value = data.uf || ''
    erroCep.value = ''
  } catch (e) {
    erroCep.value = 'Erro ao buscar endereço.'
  }
}
